/* V&V: render Appstle Subscribe & Save inside the collection quick-view modal.
   The theme's quick-view loader suffixes ids with "-modal" and drops the app block's
   inline script, so Appstle never finds its placeholder or product data. */
(function () {
  var PH = 'appstle-subscription-widget-placeholder';
  function handleFrom(url) { var m = (url || '').match(/\/products\/([^/?#]+)/); return m && m[1]; }
  function render(screen, handle) {
    if (!window.RSConfig || !handle) return;
    if (document.querySelector('#' + PH) && !document.querySelector('#' + PH).closest('.screen-layer--product')) return; // real PDP widget present
    document.querySelectorAll('.screen-layer--product').forEach(function (s) {
      if (s === screen) return;
      s.querySelectorAll('[id^="appstle_subscription_widget"]').forEach(function (w) { w.remove(); });
      var o = s.querySelector('#' + PH); if (o) o.id = PH + '-modal';
    });
    var ph = screen.querySelector('#' + PH + '-modal') || screen.querySelector('#' + PH);
    if (!ph || screen.querySelector('[id^="appstle_subscription_widget"]')) return;
    ph.id = PH;
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      window.RSConfig.product = p;
      var a = document.createElement('a');
      a.className = 'grid-product__link'; a.href = '#'; a.style.display = 'none';
      a.addEventListener('click', function (e) { e.preventDefault(); });
      document.body.appendChild(a); a.click(); a.remove();
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[class*="js-screen-open-product-"]');
    if (!a) return;
    var id = a.getAttribute('data-product-id'), handle = handleFrom(a.getAttribute('data-url') || a.getAttribute('href'));
    var tries = 0;
    (function poll() {
      var s = document.getElementById('ProductScreen-' + id);
      if (s && s.querySelector('#' + PH + '-modal, #' + PH)) { setTimeout(function () { render(s, handle); }, 300); return; }
      if (++tries < 60) setTimeout(poll, 200);
    })();
  }, true);
})();
